import {Component, Inject} from "@angular/core";
import {MAT_DIALOG_DATA} from "@angular/material";

@Component({
    selector: "iinvest-error-dialog",
    templateUrl: "./ErrorDialogComponent.html"
})
export class ErrorDialogComponent {

    public title: string;
    public message: string;

    public constructor(@Inject(MAT_DIALOG_DATA) data: ErrorDialogData) {
        this.title = data.title;
        this.message = data.message;
    }
}

export interface ErrorDialogData {
    title: string;
    message: string;
}
